/**
 * Enum that contains the list of streaming interactions used.
 */
export enum InteractionTypes {
    NONE = "NONE",
    QNA = "QNA"
}

/**
 * Data structure for Q&A
 */
export class QnA {
    public id: string
    public question: string
    public selected: boolean
    public user: string
    public uuid: string
    public date: Date
}


// WEBPACK FOOTER //
// ./src/configs/interactions-entities.ts